"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.dedupeArray = void 0;
exports.missingKeys = missingKeys;
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
function missingKeys(keys, data) {
  return (0, _reduce.default)(keys).call(keys, (missing, key) => {
    if (data[key]) {
      return missing;
    }
    missing.push(key);
    return missing;
  }, []);
}

/**
 * Deduplicate an array; works without `getKey` if the contents are scalar, but
 * `getKey` can be used to get a unique identifier if the contents are non-scalar.
 */
var dedupeArray = (list, getKey) => {
  var seen = {};
  return (0, _filter.default)(list).call(list, item => {
    var key = getKey ? getKey(item) : item;
    if (seen[key]) return false;
    seen[key] = true;
    return true;
  });
};
exports.dedupeArray = dedupeArray;